import TabListNavItem from './TabListNavItem';

export default TabListNavItem;
